import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-15d33871")

_pushScopeId("data-v-15d33871")
const _hoisted_1 = { class: "base-office-card__content" }
const _hoisted_2 = { class: "base-office-card__title" }
const _hoisted_3 = {
  key: 0,
  class: "base-office-card__price"
}
const _hoisted_4 = {
  key: 1,
  class: "base-office-card__price"
}
const _hoisted_5 = {
  key: 2,
  class: "base-office-card__payments"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", {
    class: "base-office-card",
    style: 
      _ctx.image
        ? {
            backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(${require(`@/assets/images/${_ctx.image}`)})`
          }
        : {
            backgroundColor: '#29323D'
          }
    
  }, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, _toDisplayString(_ctx.title), 1),
      (_ctx.owner && _ctx.owner.name)
        ? (_openBlock(), _createBlock("div", _hoisted_3, _toDisplayString(_ctx.$t('boardCard.pay')) + " " + _toDisplayString(_ctx.charge), 1))
        : (_openBlock(), _createBlock("div", _hoisted_4, _toDisplayString(_ctx.$t('boardCard.buy')) + " " + _toDisplayString(_ctx.price), 1)),
      _createVNode("div", {
        class: ["base-office-card__owner", { owned: _ctx.owner && _ctx.owner.name }]
      }, _toDisplayString(_ctx.owner && _ctx.owner.name ? _ctx.owner.name : _ctx.$t('boardCard.notOwned')), 3),
      (_ctx.big)
        ? (_openBlock(), _createBlock("div", _hoisted_5, [
            (_openBlock(), _createBlock(_Fragment, null, _renderList(4, (i) => {
              return _createVNode("div", { key: i }, [
                _createVNode("span", null, _toDisplayString(_ctx.$t('boardCard.ifYouHave')) + " " + _toDisplayString(i), 1),
                _createVNode("span", null, _toDisplayString(_ctx.baseCharge * i), 1)
              ])
            }), 64))
          ]))
        : _createCommentVNode("", true)
    ])
  ], 4))
})